import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import AddReworkRouteContent from "./AddReworkRouteContent";

export const AddReworkRouteDialog = ({ routeId = "", userId }) => {
  return (
    <HubDialogWrapper maxWidth="sm" name="create-route-rework">
      <AddReworkRouteContent routeId={routeId} userId={userId} />
    </HubDialogWrapper>
  );
};

export default AddReworkRouteDialog;
